import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  ContentFilter,
  LocationInterface,
  StarredItemType,
  StateInfo
} from 'types';

/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import api from '../api/locations.api';

export const locationsApi = createApi({
  reducerPath: 'locationsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getLocations: builder.query<LocationInterface[], ContentFilter>({
      queryFn: async (contentFilter) => {
        try {
          const { data } = await api.getLocations(contentFilter);

          const filteredList = data.filter(
            (location: LocationInterface) => location.name !== null
          );

          return { data: filteredList };
        } catch (error) {
          console.error(`Error while get list of locations: ${error.message}`);

          return { error };
        }
      }
    }),
    getFavoriteLocations: builder.query<StarredItemType[], string>({
      queryFn: async () => {
        try {
          const { data } = await api.getStarredItems('Locations');
          const list = Array.isArray(data) ? data : Object.values(data);

          return { data: list };
        } catch (error) {
          console.error(`Error while get favorite locations: ${error.message}`);

          return { error };
        }
      }
    }),
    addFavoriteLocations: builder.mutation({
      queryFn: async (locationId: number) => {
        try {
          const { data } = await api.setStarredItem('Locations', locationId);

          return { data };
        } catch (error) {
          console.error(`Error while add favorite location:: ${error.message}`);

          return { error };
        }
      },
      async onQueryStarted(locationId, { dispatch, queryFulfilled }) {
        const { data: response } = await queryFulfilled;

        const newLoc = {
          rel_id: Number(response?.data?.[0]?.rel_id),
          item_type: 3000,
          item_num: locationId,
          name: ''
        };

        dispatch(
          locationsApi.util.updateQueryData(
            'getFavoriteLocations',
            '',
            (draft) => {
              draft = [...draft, newLoc];
              return draft;
            }
          )
        );
      }
    }),
    deleteFavoriteLocations: builder.mutation({
      queryFn: async (locationId: number) => {
        try {
          const { data } = await api.deleteFavoriteServices(
            'Locations',
            locationId
          );

          return { data };
        } catch (error) {
          console.error(
            `Error while delete favorite location:: ${error.message}`
          );

          return { error };
        }
      },
      async onQueryStarted(locationId, { queryFulfilled, dispatch }) {
        await queryFulfilled;

        dispatch(
          locationsApi.util.updateQueryData(
            'getFavoriteLocations',
            '',
            (draft) => {
              draft = draft.filter((loca) => loca.item_num !== locationId);
              return draft;
            }
          )
        );
      }
    }),
    getStates: builder.query<StateInfo[], string>({
      queryFn: async () => {
        try {
          const { data } = await api.getStates();

          return { data };
        } catch (error) {
          console.error(`Error while get states: ${error.message}`);

          return { error };
        }
      }
    })
  })
});

export const {
  useGetFavoriteLocationsQuery,
  useAddFavoriteLocationsMutation,
  useDeleteFavoriteLocationsMutation,
  useGetStatesQuery,
  useGetLocationsQuery
} = locationsApi;
